import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Switch } from "../ui/switch";

export default function VoidWarrantySwitch({
  checked,
  disabled = false,
  onChange,
  id = "void-warranty",
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonError, setReasonError] = useState("");

  useEffect(() => {
    if (!dialogOpen) {
      setReason("");
      setReasonError("");
    }
  }, [dialogOpen]);

  const handleCheckedChange = (nextChecked) => {
    if (nextChecked) {
      setDialogOpen(true);
      return;
    }
    onChange?.({ enabled: false, reason: "" });
  };

  const confirmReason = () => {
    if (!reason.trim()) {
      setReasonError("Void Reason is required.");
      return;
    }
    onChange?.({ enabled: true, reason });
    setDialogOpen(false);
  };

  return (
    <>
      <div className="flex items-center gap-2" data-testid={`${id}-control`}>
        <label htmlFor={id} className="text-xs font-semibold text-zinc-700 dark:text-zinc-300">
          Void Warranty
        </label>
        <Switch
          id={id}
          checked={checked}
          disabled={disabled}
          onCheckedChange={handleCheckedChange}
          aria-label="Void Warranty"
          data-testid={`${id}-switch`}
        />
      </div>
      <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <DialogContent data-testid={`${id}-reason-dialog`}>
          <DialogHeader>
            <DialogTitle>Void Warranty</DialogTitle>
            <DialogDescription>
              Enter the required reason. It will be appended to Resolution when the form is saved.
            </DialogDescription>
          </DialogHeader>
          <div>
            <label htmlFor={`${id}-reason`} className="text-xs font-semibold text-zinc-700 dark:text-zinc-300">
              Void Reason
            </label>
            <textarea
              id={`${id}-reason`}
              value={reason}
              onChange={(event) => {
                setReason(event.target.value);
                if (reasonError) setReasonError("");
              }}
              className="mt-2 min-h-24 w-full resize-none rounded-sm border border-zinc-200 bg-white px-3 py-2.5 text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/10 dark:border-zinc-700 dark:bg-zinc-900"
              aria-invalid={Boolean(reasonError)}
              aria-describedby={`${id}-reason-error`}
              autoFocus
            />
            <p id={`${id}-reason-error`} className="mt-1 min-h-[18px] text-xs text-destructive">
              {reasonError}
            </p>
          </div>
          <DialogFooter>
            <Button type="button" variant="cancel" onClick={() => setDialogOpen(false)}>
              Cancel
            </Button>
            <Button type="button" variant="success" onClick={confirmReason}>
              Confirm
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
